// Keep insertion order in sync with
// kotlin/service/item-store/src/main/kotlin/itemtype/service/ItemTypeDefaults.kt.
import {
  Assignment,
  Bolt,
  BugReport,
  Build,
  BusinessCenter,
  FactCheck,
  FavoriteBorder,
  Inventory,
  Lightbulb,
  Radar,
  RocketLaunch,
  Star,
  Support,
  Task,
} from '@tempo-io/sui-icons';

export const ItemTypeIcons = {
  assignment: { name: 'Assignment', icon: Assignment, value: 'assignment' },
  bolt: { name: 'Bolt', icon: Bolt, value: 'bolt' },
  briefcase: { name: 'Briefcase', icon: BusinessCenter, value: 'briefcase' },
  bug: { name: 'Bug', icon: BugReport, value: 'bug' },
  build: { name: 'Build', icon: Build, value: 'build' },
  factCheck: { name: 'Fact Check', icon: FactCheck, value: 'factCheck' },
  heart: { name: 'Heart', icon: FavoriteBorder, value: 'heart' },
  inventory: { name: 'Inventory', icon: Inventory, value: 'inventory' },
  lightbulb: { name: 'Lightbulb', icon: Lightbulb, value: 'lightbulb' },
  radar: { name: 'Radar', icon: Radar, value: 'radar' },
  rocket: { name: 'Rocket', icon: RocketLaunch, value: 'rocket' },
  star: { name: 'Star', icon: Star, value: 'star' },
  support: { name: 'Support', icon: Support, value: 'support' },
  task: { name: 'Task', icon: Task, value: 'task' },
} as const;

export type ItemTypeIcon = (typeof ItemTypeIcons)[keyof typeof ItemTypeIcons];
export type ItemTypeIconValue = ItemTypeIcon['value'];
